import script from "./GrafoRolesUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./GrafoRolesUsuario.vue?vue&type=script&setup=true&lang=js"

import "./GrafoRolesUsuario.vue?vue&type=style&index=0&id=496bb6bc&lang=scss&scoped=true"

import exportComponent from "C:\\AgentesAzure\\SVRAPPHIR04\\vsts-agent-win-x64-4.261.0\\_work\\6\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496bb6bc"]])

export default __exports__